import { Component, OnInit } from '@angular/core';
import { DialogWizardComponent } from '../../../../shared/dialog-wizard/dialog-wizard.component';
import { NbDialogRef } from '@nebular/theme';
import { ProfitMarginType } from '../profit-margin.component';

@Component({
  selector: 'ngx-project-finalization',
  templateUrl: './project-finalization.component.html',
  styleUrls: ['./project-finalization.component.scss']
})
export class ProjectFinalizationComponent extends DialogWizardComponent {

  profitMarginType = ProfitMarginType;

  constructor(dialogRef: NbDialogRef<any>) { 
    super(dialogRef);
  }

}
